
















import { Component, Vue } from "vue-property-decorator";
import { Loading } from "vant";

Vue.use(Loading);

var eventHub = new Vue();
Vue.prototype.show = (info: any) => {
  eventHub.$emit("showLoading", info);
};
Vue.prototype.hide = () => {
  eventHub.$emit("hideLoading");
};

@Component
export default class Toast extends Vue {
  show = false;
  title = "";

  mounted() {
    eventHub.$on("showLoading", (info: any) => {
      this.title = info;
      this.show = true;
    });
    eventHub.$on("hideLoading", () => {
      this.show = false;
    });
  }
}
